/* ═══════════════════════════════════════════════
   PULZENA — Scroll Animations (IntersectionObserver)
   Sections : fade-in au scroll
   Grilles  : stagger cards (observer parent → CSS delays)
   ═══════════════════════════════════════════════ */

(function () {
  if (!('IntersectionObserver' in window)) return;

  /* Sections à animer au scroll (fade-in global) */
  var SECTION_SELECTORS = [
    '.pz-trust',
    '.pz-collections',
    '.pz-bestsellers',
    '.pz-reviews',
    '.pz-features',
    '.shopify-section--image-with-text',
    '.shopify-section--multirow',
    '.shopify-section--blog-posts',
    '.shopify-section--newsletter',
  ].join(', ');

  /* Grilles dont les enfants doivent staggers */
  var STAGGER_SELECTORS = [
    '.pz-product-grid',
    '.pz-bs-grid',
    '.pz-reviews-grid',
    '.pz-features-grid',
    '.multi-column__grid',
  ].join(', ');

  var OBS_OPTIONS = {
    threshold: 0.07,
    rootMargin: '0px 0px -48px 0px',
  };

  function init() {
    /* ── 1. Fade-in sections ── */
    var sections = document.querySelectorAll(SECTION_SELECTORS);
    sections.forEach(function (el) {
      el.classList.add('pz-fade-in');
    });

    var sectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('pz-visible');
          sectionObserver.unobserve(entry.target);
        }
      });
    }, OBS_OPTIONS);

    sections.forEach(function (el) {
      sectionObserver.observe(el);
    });

    /* ── 2. Stagger grilles ──
       On cache les enfants et on observe la GRILLE.
       Quand la grille entre dans le viewport, on déclenche
       toutes les cards simultanément → les CSS nth-child delays
       créent le décalage visuel. */
    var grids = document.querySelectorAll(STAGGER_SELECTORS);

    grids.forEach(function (grid) {
      var cards = Array.from(grid.children);
      cards.forEach(function (card) {
        card.classList.add('pz-fade-in');
      });

      var gridObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            Array.from(entry.target.children).forEach(function (card) {
              card.classList.add('pz-visible');
            });
            gridObserver.unobserve(entry.target);
          }
        });
      }, OBS_OPTIONS);

      gridObserver.observe(grid);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Normalize legacy delivery copy that can linger in Shopify page cache. */
(function () {
  var DELIVERY_PATTERN = /7\s*(?:à|a|-)\s*15 jours ouvrés/g;

  function normalizeDeliveryCopy(root) {
    var scope = root && root.nodeType === 1 ? root : document.body;
    if (!scope || !scope.textContent || !DELIVERY_PATTERN.test(scope.textContent)) return;

    DELIVERY_PATTERN.lastIndex = 0;
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null);
    var node;

    while ((node = walker.nextNode())) {
      if (DELIVERY_PATTERN.test(node.nodeValue)) {
        DELIVERY_PATTERN.lastIndex = 0;
        node.nodeValue = node.nodeValue.replace(DELIVERY_PATTERN, '5 à 7 jours ouvrés');
      }
      DELIVERY_PATTERN.lastIndex = 0;
    }
  }

  function initDeliveryCopyNormalization() {
    normalizeDeliveryCopy(document.body);

    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            normalizeDeliveryCopy(node);
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDeliveryCopyNormalization);
  } else {
    initDeliveryCopyNormalization();
  }
})();

/* 17TRACK renders its tracking widget after page load, so the public CTA copy
   needs a tiny scoped observer instead of a static Liquid translation. */
(function () {
  if (!document.body || !document.body.classList.contains('pz-17track-page')) return;

  var accent = '#0e1a2b';
  var accentHover = '#162540';
  var beige = '#f5f3ef';

  if (window.history && window.history.replaceState && window.location.pathname.toLowerCase() === '/apps/17track') {
    window.history.replaceState(null, '', '/apps/suivi-de-commande' + window.location.search + window.location.hash);
  }

  function styleTrackingPage() {
    var app = document.querySelector('#__next .yq-app, .yq-app');
    if (app) {
      app.style.setProperty('--yq-button-brand-color', 'rgba(14, 26, 43, 1)', 'important');
      app.style.setProperty('--yq-button-brand-secondary-color', 'rgba(14, 26, 43, 0.68)', 'important');
      app.style.setProperty('--yq-progress-color', 'rgba(14, 26, 43, 1)', 'important');
      app.style.setProperty('--yq-tab-color', 'rgba(14, 26, 43, 0.10)', 'important');
    }

    var next = document.querySelector('#__next');
    if (next && !next.querySelector('.pz-17track-accent-line')) {
      var accentLine = document.createElement('div');
      accentLine.className = 'pz-17track-accent-line';
      accentLine.setAttribute('aria-hidden', 'true');
      accentLine.style.cssText = 'width:min(96px,22vw);height:3px;margin:0 auto;background:' + accent + ';border-radius:999px;';
      next.insertBefore(accentLine, next.firstChild);
    }

    var buttons = document.querySelectorAll('#__next button, #__next [role="button"], .yq-app button, .yq-app [role="button"]');
    buttons.forEach(function (button) {
      var label = (button.textContent || '').trim().toLowerCase();
      if (label === 'suivre' || label === 'suivre ma commande') {
        if (label === 'suivre') {
          button.textContent = 'Suivre ma commande';
        }
        button.setAttribute('aria-label', 'Suivre ma commande');
        button.style.setProperty('background', accent, 'important');
        button.style.setProperty('background-color', accent, 'important');
        button.style.setProperty('border-color', accent, 'important');
        button.style.setProperty('color', beige, 'important');
        button.style.setProperty('letter-spacing', '0.16em', 'important');
        button.style.setProperty('text-transform', 'uppercase', 'important');

        if (!button.dataset.pz17trackAccent) {
          button.dataset.pz17trackAccent = 'true';
          button.addEventListener('mouseenter', function () {
            button.style.setProperty('background', accentHover, 'important');
            button.style.setProperty('background-color', accentHover, 'important');
            button.style.setProperty('border-color', accentHover, 'important');
          });
          button.addEventListener('mouseleave', function () {
            button.style.setProperty('background', accent, 'important');
            button.style.setProperty('background-color', accent, 'important');
            button.style.setProperty('border-color', accent, 'important');
          });
        }
      }
    });

    var activeTabs = document.querySelectorAll('#__next .yq-track-num-active, .yq-app .yq-track-num-active');
    activeTabs.forEach(function (activeTab) {
      activeTab.style.setProperty('color', accent, 'important');
      activeTab.style.setProperty('border-color', accent, 'important');
      activeTab.style.setProperty('border-bottom', '2px solid ' + accent, 'important');
      activeTab.style.setProperty('box-shadow', 'inset 0 -1px 0 ' + accent, 'important');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', styleTrackingPage);
  } else {
    styleTrackingPage();
  }

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(styleTrackingPage);
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
